import * as THREE from 'three';
class BaseMesh extends THREE.Mesh {
    props;
    center;
    isObserver; // 是否被射线监听
    needDeep; // 是否需要递归搜索
    meshId;
    _map;
    constructor(data) {
        super(new THREE.PlaneBufferGeometry(1, 1), new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 }));
        if (!data)
            throw new Error('basemesh参数为空');
        const { visible = true, zIndex = 0, onLoad, position } = data;
        this.props = data;
        this.needDeep = true;
        // init
        this.visible = visible;
        this.isObserver = true;
        this.center = this.position;
        this.position.x = position.x;
        this.position.y = position.y;
        this.position.z = zIndex;
        // this.name = this.props.name;
        this.name = this.uuid;
        this.meshId = this.props.name;
        // this.geometry.position.z = zIndex;
        if (onLoad && typeof onLoad === 'function') {
            onLoad(this);
        }
    }
    onClick() {
        // clickEvent
        if (this.props.onClick && typeof (this.props.onClick === 'function')) {
            this.props.onClick(this);
        }
    }
    onMouseDown() {
        // mouseDownEvent
        if (this.props.onMouseDown && typeof (this.props.onMouseDown === 'function')) {
            this.props.onMouseDown(this);
        }
    }
    onMouseUp() {
        // mouseUpEvent
        if (this.props.onMouseUp && typeof (this.props.onMouseUp === 'function')) {
            this.props.onMouseUp(this);
        }
    }
    onMouseEnter() {
        // mouseEnterEvent
        if (this.props.onMouseEnter && typeof (this.props.onMouseEnter === 'function')) {
            this.props.onMouseEnter(this);
        }
    }
    onMouseLeave() {
        // mouseLeaveEvent
        if (this.props.onMouseLeave && typeof (this.props.onMouseLeave === 'function')) {
            this.props.onMouseLeave(this);
        }
    }
    update(data) {
        const { visible = true, position, onUpdate } = data;
        this.visible = visible;
        this.position.x = position.x;
        this.position.y = position.y;
        this.position.z = position.z;
        // 处理完更新操作后替换props
        this.props = data;
        if (onUpdate && typeof onUpdate === 'function') {
            onUpdate(this);
        }
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default BaseMesh;
